
/**
 * This file is part of "Zona franca"
 * Copyright (c) 2022
 * Zona franca
 * All rights reserved
 *
 * @author Turiano Romero <https://bitbucket.org/rome9603/ | tromero@technisupport.com>
 * @version 2.0
 */

export const authTypes = {
  // Types Auth
  resetStateAuth: "[auth] reset state",
  login: "[auth] login user",
  logout: "[auth] logout user",
  updateFreeZone: "[auth] update free zone",
  renewToken: "[auth] renew token",
  sessionExpired: "[auth] session expired"
};
